import { generatePath } from "react-router-dom";

import { URLS } from "@/api/urls";

import fetcher_v2 from "../fetcher_v2";

export const getPublicReportFromToken = (token: string) =>
  fetcher_v2(generatePath(URLS.PUBLIC_REPORT_BY_TOKEN, { token }));
